/**
 * Dimension Input Settings sub-dialog.
 *
 * Opened from DynamicInputTab via the "Settings..." button next to the
 * Dimension Input section. Mirrors the AutoCAD 2024 nested dialog for
 * DYNDIVIS — controls how many dimension input fields are shown.
 *
 *   DYNDIVIS=1 → show only one (primary) field
 *   DYNDIVIS=2 → show both primary and secondary fields
 */

import { useState } from "react";

import { useT } from "../../i18n";
import { useSysvarStore } from "../sysvarStore";

export type DimInputSettingsSubdialogProps = {
  onClose: () => void;
};

export function DimInputSettingsSubdialog({
  onClose,
}: DimInputSettingsSubdialogProps) {
  const t = useT();
  const dynDivis = useSysvarStore((s) => s.values.DYNDIVIS);
  const setVar = useSysvarStore((s) => s.setVar);

  // Local draft so changes apply only on OK
  const [diVis, setDiVis] = useState(dynDivis);

  function handleOk() {
    setVar("DYNDIVIS", diVis);
    onClose();
  }

  return (
    <div
      className="dsettings-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        className="dsettings-content dsettings-subdialog"
        role="dialog"
        aria-modal="true"
        aria-label={t("dsettings.di.title")}
      >
        <div className="dsettings-title">{t("dsettings.di.title")}</div>

        <div className="dsettings-section">
          <div className="dsettings-section-title">
            {t("dsettings.di.fields.title")}
          </div>
          <label className="dsettings-radio-row">
            <input
              type="radio"
              name="di-vis"
              value="1"
              checked={diVis === 1}
              onChange={() => setDiVis(1)}
            />
            <span>{t("dsettings.di.one")}</span>
          </label>
          <label className="dsettings-radio-row">
            <input
              type="radio"
              name="di-vis"
              value="2"
              checked={diVis === 2}
              onChange={() => setDiVis(2)}
            />
            <span>{t("dsettings.di.two")}</span>
          </label>
        </div>

        <div className="dsettings-footer">
          <button
            type="button"
            className="dsettings-btn primary"
            onClick={handleOk}
          >
            {t("dsettings.ok")}
          </button>
          <button
            type="button"
            className="dsettings-btn"
            onClick={onClose}
          >
            {t("dsettings.cancel")}
          </button>
        </div>
      </div>
    </div>
  );
}
